import { render, staticRenderFns } from "./uniformConfirm.vue?vue&type=template&id=0bd93fd4&scoped=true&"
import script from "./uniformConfirm.vue?vue&type=script&lang=js&"
export * from "./uniformConfirm.vue?vue&type=script&lang=js&"
import style0 from "./uniformConfirm.vue?vue&type=style&index=0&id=0bd93fd4&scoped=true&lang=less&"
import style1 from "./uniformConfirm.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd93fd4",
  null
  
)

export default component.exports